const e = "Вже використовується", r = (r2, s2) => {
  switch (r2) {
    case "NotNullValidator":
    case "NotEmptyValidator":
      return "Обовʼязково для заповнення";
    case "AsyncPredicateValidator":
      return "Невірний формат";
    case "AlreadyExists":
      return e;
    default:
      return s2;
  }
}, s = (e2, s2, a = "Ой, щось пішло не так") => {
  var _a, _b, _c, _d, _e, _f;
  try {
    const a2 = e2;
    if (!a2) return;
    if (400 !== (a2 == null ? void 0 : a2.status) || (((_a = a2 == null ? void 0 : a2.data) == null ? void 0 : _a.errors) || []).some((e3) => {
      var _a2;
      return (_a2 = e3.propertyName) == null ? void 0 : _a2.startsWith("$");
    })) throw e2;
    return (_c = (_b = a2 == null ? void 0 : a2.data) == null ? void 0 : _b.errors) == null ? void 0 : _c.reduce((e3, a3) => a3.propertyName in e3 ? e3 : a3.propertyName ? (a3.errorMessage.includes("already exists") || a3.errorMessage.includes("is used by other") || a3.errorMessage.includes("already in use") || a3.errorMessage.includes("should be unique") ? e3[a3.propertyName] = r("AlreadyExists") : s2 && s2.includes(a3.propertyName) ? e3[a3.propertyName] = a3.errorMessage : e3[a3.propertyName] = r(a3.errorCode, a3.errorMessage), e3) : (e3.general = a3.errorMessage, e3), {});
  } catch (e3) {
    const r2 = (_f = (_e = (_d = e3 == null ? void 0 : e3.data) == null ? void 0 : _d.errors) == null ? void 0 : _e[0]) == null ? void 0 : _f.errorMessage;
    return { message: r2 || a };
  }
};
export {
  e as ALREADY_IN_USE,
  s as default,
  r as getServerErrorMsgByCode
};
//# sourceMappingURL=normalizeServerErrors.js.map
